module.exports = __webpack_public_path__ + "static/media/beep-6-96243.26dd5f48.mp3";